import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { downloadAsset, getUserDownloads, limitDownloadsAmount } from "../../actions/downloads";
import { TSetOptimisticDownloadCountPayload } from "./types";

export type DownloadsState = {
  downloadsLimit?: number;
  albumsCount?: number;
  tracksCount?: number;
  isDownloading?: boolean;
};

const initialState: DownloadsState = { isDownloading: true };

const { actions, reducer } = createSlice({
  name: "downloads",
  initialState,
  reducers: {
    setOptimisticDownloadCount: (state, action: PayloadAction<TSetOptimisticDownloadCountPayload>) => {
      const { payload } = action;

      if (payload.isAlbum) {
        state.albumsCount = state.albumsCount + 1;
      }
      state.tracksCount = state.tracksCount + 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(limitDownloadsAmount.fulfilled, (state, { payload }) => {
      state.downloadsLimit = payload;
    });
    builder.addCase(getUserDownloads.fulfilled, (state, { payload }) => {
      state.albumsCount = payload.albumDownloadCount;
      state.tracksCount = payload.trackDownloadCount;
    });
    builder.addCase(downloadAsset.pending, (state) => {
      state.isDownloading = true;
    });
    builder.addCase(downloadAsset.fulfilled, (state) => {
      state.isDownloading = false;
    });
  },
});

export const { setOptimisticDownloadCount } = actions;
export default reducer;
